"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withPrefix = exports.OTEL_TRACER_NAME = void 0;
exports.OTEL_TRACER_NAME = 'socket-frontend-sdk';
function withPrefix(name) {
    return "".concat(exports.OTEL_TRACER_NAME, ".").concat(name);
}
exports.withPrefix = withPrefix;
//# sourceMappingURL=instrumentation.js.map